<template>
	<div class="home-page-container">
		<div class="lang-switch-wrapper">
			<div class="welcome-text">
				<span class="user-name">{{ userName }}，</span>
				{{ welcomeText }}
			</div>

			<van-popover
				v-model="showLangMenu"
				trigger="click"
				:actions="langActions"
				placement="bottom-end"
				:get-container="getContainer"
				@select="onSelectLang">
				<template #reference>
					<div class="lang-switch-btn">
						<img src="@/assets/icon/home-page/international.png" class="lang-icon" alt="lang-icon" />
						<span class="lang-text">{{ currentLangText }}</span>
					</div>
				</template>
			</van-popover>
		</div>
		<fee-card :title="unpaidFeeTitle" :listArr="unpaidFeeList" class="flex-grow-card"></fee-card>
		<fee-card :title="chooseFeeTitle" :listArr="chooseFeeList" class="flex-grow-card"></fee-card>
		<fee-card :title="personalServiceTitle" :listArr="personalServiceList" class="flex-grow-card"></fee-card>
	</div>
</template>

<script>
import log from 'utils/log'
import utils from '@/utils/util'
import db from '@/utils/db'
import { loadUserInfo } from '@/utils/cache'
import feeCard from 'components/fee-card/index'
import apiChooseFee from 'api/choose-fee'
// import {getState, setState} from "utils/state";
import storage from 'good-storage'

export default {
	name: 'HomePage',
	components: {
		feeCard
	},
	data() {
		return {
			welcomeText: this.$t('home.welcome_text'),
			unpaidFeeTitle: this.$t('router.pay.unpaid_fee'),
			chooseFeeTitle: this.$t('router.pay.choose_fee'),
			personalServiceTitle: this.$t('router.pay.self_service.title'),
			unpaidFeeList: [
				{
					name: '学杂费',
					router: 'unpaid-fee',
					src: 'unpaid-fee',
					param: { code: 'XZF' }
				},
				{
					name: '辅修费',
					router: 'unpaid-fee',
					src: 'pay-fxf',
					param: { code: 'FXF' }
				},
				{
					name: '培训费',
					router: 'unpaid-fee',
					src: 'pay-pxf',
					param: { code: 'PXF' }
				},
				{
					name: '考试费',
					router: 'unpaid-fee',
					src: 'pay-ksf',
					param: { code: 'KSF' }
				},
				{
					name: '其他待交费用',
					router: 'unpaid-fee',
					src: 'pay-more',
					param: { code: 'QTYSF' }
				}
			],
			chooseFeeList: [
				{
					name: '网费',
					router: 'https://cas.sysu.edu.cn/cas/login?service=https://netpay.sysu.edu.cn/netpay/workwx',
					src: 'pay-net',
					type: 'external'
				},
				{
					name: '教职工零星退款',
					router: 'choose-fee-detail',
					src: 'pay-jzglxtf',
					style: 'font-size:13px;',
					param: { code: '81100165' },
					needCheck: true,
					show: false
				}
				// {
				//     name: '即将开放',
				//     router: '',
				//     src: '',
				// }
				// {
				//     name: '水电预付费',
				//     router: 'https://sdwpay.sysu.edu.cn/wx/wechat/index.jsp',
				//     src: 'pay-sdf',
				//     type:'external',
				// },
				// {
				//     name: '即将开放',
				//     router: '',
				//     src: '',
				// }
			],
			personalServiceList: [
				{
					name: this.$t('router.pay.self_service.pay_situation'),
					router: 'pay-situation',
					src: 'pay-situation'
				},
				/* {
                         name: '退费记录',
                         router: 'pay-refund',
                         src: 'pay-refund',
                     },*/
				{
					name: this.$t('router.pay.self_service.pay_record'),
					router: 'pay-record',
					src: 'pay-record'
				}
			],
			showLangMenu: false,
			langActions: [
				{ text: '中文', value: 'zh' },
				{ text: 'English', value: 'en' }
			]
		}
	},
	computed: {
		userName() {
			let user = loadUserInfo()
			return user.userName || ''
		},
		currentLangText() {
			const currentLang = db.get('sys.public.language.value').value() || 'zh'
			return currentLang === 'zh' ? '中文' : 'EN'
		}
	},
	mounted() {
		if (window.history && window.history.pushState) {
			window.addEventListener('popstate', this.backChange, false)
		}
	},
	created() {
		//alert(document.URL)
		//history.pushState(null, null, document.URL);
		if (utils.isWxWorkBrowser()) {
			history.pushState(null, null, document.URL)
		}
		this.handleChooseFeeList()
	},
	methods: {
		backChange() {
			//alert(window.location.href);
			if (window.location.href.endsWith('/home')) {
				if (utils.isWxWorkBrowser()) {
					history.pushState(null, null, document.URL)
				}
			}
			if (window.location.href.indexOf('commsso') > -1) {
				let commssoUrl = process.env.VUE_APP_FIS_COMMSSO_URL
				window.location.href = commssoUrl
			}
		},
		onSelectLang(action) {
			console.log('language:', action.value)
			const selectedLang = action.value
			db.set('sys.public.language.value', selectedLang).write()
			location.reload()
		},
		getChooseFeeList() {
			// apiChooseFee.list().then(res => {
			//     let d = res.data || []
			//     if (d.length > 5) {
			//         let t = d.slice(0, 4)
			//         let t2 = this.generateList(t)
			//         let t3 = [
			//             {
			//                 name: '查看全部',
			//                 router: 'choose-fee',
			//                 icon: 'more',
			//             }
			//         ]
			//         this.chooseFeeList = [...t2, ...t3]
			//     } else {
			//         this.chooseFeeList = this.generateList(d)
			//     }
			// })
		},

		generateList(item) {
			let that = this
			return item.map(t => {
				return {
					name: t.itemName,
					data: t,
					onClick: item => that.clickItem(item)
				}
			})
		},

		handleChooseFeeList() {
			let tmp = []
			this.chooseFeeList.forEach(item => {
				if (item.needCheck) {
					apiChooseFee.checkEnabled(item.param).then(res => {
						if (res.data) {
							//console.log("data",res.data);
							item.show = true
						} else {
							item.show = false
						}
					})
				}
			})
		},

		clickItem(item) {
			log('item', item)
			// setState('select-item', item.data)
			storage.session.set('select-item', item.data)
			this.$router.push({
				name: 'choose-fee-detail'
			})
		},
		getContainer() {
			return document.querySelector('.lang-switch-wrapper')
		}
	}
}
</script>

<style lang="scss" scoped>
.lang-switch-wrapper {
	width: 100%;
	display: flex;
	justify-content: space-between; /* 关键：让左边的欢迎语和右边的按钮各贴一边 */
	align-items: center; /* 关键：让文字和按钮在垂直方向完美居中对齐 */
	padding: 12px 16px 12px 16px; /* 适当调整上下左右内边距 */
	box-sizing: border-box;
	background: linear-gradient(0deg, #f2f9f5 0%, #ffffff 100%);
	margin-bottom: 10px;
}

.welcome-text {
	font-size: 15px; /* 采用 14px，比大标题稍微小一点，主次分明 */
	color: #666666; /* 浅黑色，低调优雅 */
	font-family: -apple-system, sans-serif;
}

/* 欢迎语中用户名字加粗，使其更醒目 */
.user-name {
	font-weight: 600;
	color: #111111; /* 名字用稍深的颜色突出 */
}

.lang-switch-btn {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	padding: 4px 10px;
	height: 26px;
	border: 1px solid #e0e0e0;
	border-radius: 13px;
	background-color: #ffffff;
	transition: all 0.2s ease;
	cursor: pointer;
	user-select: none;
	-webkit-user-select: none;
}

/* 按钮内的文字样式 */
.lang-text {
	font-size: 13px;
	color: #555555; /* 选用深灰色，既能看清，又不会比业务图标更抢戏 */
	font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
}

.lang-icon {
	width: 16px;
	height: 16px;
	margin-right: 4px;
	object-fit: contain;
}

/* 移动端点击态反馈（提升用户体验） */
.lang-switch-btn:active {
	background-color: #f5f5f5;
	border-color: #cccccc;
	transform: scale(0.95); /* 轻轻下压的Q弹效果 */
}

/* 1. 缩减整个气泡菜单的宽度 */
/deep/ .van-popover {
	min-width: 50px !important; /* 限制最小宽度，让它跟右上角按钮差不多宽 */
}

/* 2. 缩减每一个选项（中文、English）的内边距和高度 */
/deep/ .van-popover__action {
	width: 90px !important;
	height: 34px !important; /* 降低每个选项的高度（默认通常是 44px） */
	padding: 0 12px !important; /* 缩减左右边距 */
}

/* 3. 让选项里的文字更精致 */
/deep/ .van-popover__action-text {
	font-size: 13px !important; /* 稍微缩小一点菜单字体 */
	color: #333333 !important; /* 稍微加深文字颜色，看起来更清晰 */
}

/* 4. 消除选项之间的自带分割线或微调边框 */
/deep/ .van-popover__action-text::after {
	border-bottom-width: 1px !important;
	border-color: #f2f3f5 !important; /* 让分割线颜色更淡、更高级 */
}
</style>
